import * as React from 'react';
import { di } from 'react-magnetic-di';
import { PORTAL_FOOTER_MODULE } from 'view/common/forge-ui/constants';
import { ForgeRunnerModule } from 'view/forge-ui/forge-runner';
import { ForgeRunnerContainer } from 'view/forge-ui/forge-runner/styled';
import type { ForgePagePanelCommonProps } from 'view/common/forge-ui/types';

const ForgeFooterModule: React.FC<ForgePagePanelCommonProps> = ({
    page,
    portalId,
    projectId,
    requestKey,
    requestTypeId,
    noWrapper,
    allowCustomPadding,
}) => {
    di(ForgeRunnerModule);
    return (
        <ForgeRunnerContainer allowCustomPadding={allowCustomPadding}>
            <ForgeRunnerModule
                type={PORTAL_FOOTER_MODULE}
                page={page}
                projectId={projectId}
                portalId={portalId}
                requestKey={requestKey}
                requestTypeId={requestTypeId}
                noWrapper={noWrapper}
            />
        </ForgeRunnerContainer>
    );
};

export default ForgeFooterModule;
